// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a83f3f34","557":"b3c35f11"}[chunkId] + ".chunk.js";
};